import { Chip, Tooltip } from '@ds';
import { SectionRow } from '@features/components/CaseOverview/components';
import { WithdrawalOfLifeSupportRecord, WOLSType } from '@/api/apis/case';

interface WolsLocationRowProps {
  wolsRecord?: WithdrawalOfLifeSupportRecord;
}

export const WolsLocationRow = ({ wolsRecord }: WolsLocationRowProps) => {
  const wolsItem = wolsRecord?.item;
  const wols = wolsItem?.answer;
  const wolsText = wols === WOLSType.Other ? (wolsItem?.text ?? null) : null;

  return (
    <SectionRow label="WOLS Location">
      <div className="flex flex-col gap-1">
        {wols ? <Chip size="sm">{wols}</Chip> : '-'}
        {wolsText && (
          <Tooltip
            className="text-m-r!"
            content={
              <div className="max-w-[300px] whitespace-normal wrap-break-word text-xs-r text-base-5">{wolsText}</div>
            }
            showArrow
          >
            <span className="truncate max-w-[240px] text-xs-r text-base-5">{wolsText}</span>
          </Tooltip>
        )}
      </div>
    </SectionRow>
  );
};
